import Error from './error.vue'
import Empty from './empty.vue'

/**
 * Common UI routes
 */
export default [
  {
    name: 'error',
    path: '/error',
    component: Error
  },
  {
    name: 'empty',
    path: '/-',
    component: Empty,
    meta: {
      secure: false
    }
  }
]
